/** お問い合わせ項目が「来店して相談したい」(value=1) のときのみ来店日時を表示する */
const initVisitDatetimeVisibility = (container) => {
    const typeSelect = container.querySelector("#type");
    const visitFields = container.querySelectorAll(".js-visit-datetime-field");
    if (!typeSelect || visitFields.length === 0) return;

    const updateVisibility = () => {
        const isVisitConsultation = typeSelect.value === "visit_consultation";
        visitFields.forEach((el) => {
            el.style.display = isVisitConsultation ? "" : "none";
        });
    };

    typeSelect.addEventListener("change", updateVisibility);
    updateVisibility();
};

/** ご希望の連絡方法に応じて電話番号・メールアドレスの必須表示（data-required/data-any）を切り替える */
const initPreferredContactMethodRequired = (container) => {
    const emailRow = container.querySelector(
        ".c-forms-row-contact-fields__email",
    );
    const phoneRow = container.querySelector(
        ".c-forms-row-contact-fields__tel",
    );
    const radios = container.querySelectorAll(
        'input[name="preferred_contact_methods"]',
    );
    if (!emailRow || !phoneRow || radios.length === 0) return;

    const setRowTag = (row, required) => {
        const tag = row?.querySelector(".c-forms-row__tag");
        if (!tag) return;
        tag.removeAttribute("data-required");
        tag.removeAttribute("data-any");
        if (required) {
            tag.setAttribute("data-required", "");
            tag.textContent = "必須";
        } else {
            tag.setAttribute("data-any", "");
            tag.textContent = "任意";
        }
    };

    const updateRequiredTags = () => {
        const checked = container.querySelector(
            'input[name="preferred_contact_methods"]:checked',
        );
        const value = checked ? checked.value : "";
        setRowTag(emailRow, value === "email"); // メールのみ
        setRowTag(phoneRow, value === "phone"); // 電話
    };

    radios.forEach((r) => r.addEventListener("change", updateRequiredTags));
    updateRequiredTags();
};

const main = () => {
    const container = document.querySelector("#page-contact");
    if (container == null) return;

    initVisitDatetimeVisibility(container);
    initPreferredContactMethodRequired(container);
};

export default main;
